import React from "react";
import { List, Datagrid, TextField } from "react-admin";
import { TimeField } from "../../components/common/TimeField";
import { CutoffJsonFilter } from "../index";

export const CutoffJsonList = (props) => (
  <List
    {...props}
    filters={<CutoffJsonFilter />}
    sort={{ field: "id", order: "DESC" }}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField
        label="Institute Id"
        name={"institute_id"}
        source="institute_id"
      />

      <TimeField label="Created" name={"Created on"} source="createdAt" />
      <TimeField label="Updated" name={"Updated on"} source="updatedAt" />
    </Datagrid>
  </List>
);
